<div class="row">
    <div class="col-12">
        <form [formGroup]="loginForm">
            <div class="row">
                <div class="col input-group">
                    <input
                        [placeholder]="'auth.email-placeholder' | translate"
                        type="text"
                        id="username"
                        class="form-control"
                        formControlName="username"
                        (change)="resetPasswordField()"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            !loginForm.controls['username'].valid &&
                            loginForm.controls['username'].touched
                        "
                    >
                        <span
                            [hidden]="
                                !loginForm.controls['username'].errors.required
                            "
                        >{{ 'auth.email-required' | translate }}</span>
                        <span
                            [hidden]="
                                !loginForm.controls['username'].errors.email
                            "
                        >{{ 'auth.email-invalid' | translate }}</span>
                    </div>
                </div>
            </div>
            <on-loading *ngIf="isLoadingAuthTypes"></on-loading>
            <div class="row password-row" *ngIf="showPassword">
                <div class="col-12 input-group">
                    <input
                        [placeholder]="'auth.password' | translate"
                        type="password"
                        id="password"
                        class="form-control"
                        formControlName="password"
                    />
                    <div
                        class="invalid-feedback"
                        *ngIf="
                            !loginForm.controls['password'].valid &&
                            loginForm.controls['password'].touched
                        "
                    >
                        <div
                            [hidden]="
                                !loginForm.controls['password'].errors.required
                            "
                        >{{ 'auth.password-required' | translate }}</div>
                    </div>
                </div>
                <div class="col text-center">
                    <a
                        class="forgotten-password-link"
                        [routerLink]="['/lostpassword']"
                        >{{ 'auth.forgot-password-title' | translate }}</a
                    >
                </div>
            </div>

            <div class="row" *ngIf="showMicrosoft">
                <div class="col">
                    <br />
                    <a
                        class="microsoft-button"
                        [href]="
                            '/api/v2/account/connectmicrosoft?login=' +
                            loginForm.controls['username'].value +
                            (route.snapshot.queryParams['returnUrl'] ? '&returnUrl=' + route.snapshot.queryParams['returnUrl'] : '')
                        "
                    >
                        <img src="/assets/images/ms-logo.png" />
                        {{ 'auth.sign-in-with-microsoft' | translate }}</a
                    >
                </div>
            </div>

            <div class="row" *ngIf="showPassword || !showMicrosoft">
                <div class="w-100"></div>
                <div class="col text-center">
                    <br />
                    <button class="btn btn-primary" (click)="Login()">
                        {{ 'auth.sign-in' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
<br />
<div class="row justify-content-center" *ngIf="!showMicrosoft">
    <div class="col text-center">
        <span>{{ 'auth.no-account-yet' | translate }}</span>
    </div>
    <div class="w-100"></div>
    <div class="col text-center">
        <button
            class="btn"
            routerLink="/register"
            [queryParams]="route.snapshot.queryParams"
        >
            {{ 'auth.create-account' | translate }}
        </button>
    </div>
</div>
